module.exports = __webpack_public_path__ + "static/img/book21.72bb871.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book21.jpg
// module id = g7Zw
// module chunks = 1